'use client';

import { useEffect } from 'react';
import { useDataLayer } from '../dataLayer';
import { Hash } from './Hash';

export const useCookieLinkObserver = () => {
    const { showPrivacyCenter } = useDataLayer();

    useEffect(() => {
        const cookieLink = document.querySelector(`[href="${Hash.CookiesPolicy}"]`) as HTMLLinkElement;

        const handleCookieLinkClick = (event: MouseEvent) => {
            event.preventDefault();
            showPrivacyCenter();
        };

        cookieLink?.addEventListener('click', handleCookieLinkClick);

        return () => {
            cookieLink?.removeEventListener('click', handleCookieLinkClick);
        };
    }, [showPrivacyCenter]);
};
